import React, { ComponentProps, FC } from 'react';
import styled from 'styled-components';

import { Icon } from '../../Icon';

type IconType = ComponentProps<typeof Icon>;

interface SubRowToggleProps {
  isExpanded: boolean;
  handleToggle: () => void;
  className?: string;
  iconExpandLessName?: IconType['name'];
  iconExpandMoreName?: IconType['name'];
  iconSize?: IconType['size'];
  iconIsInverted?: IconType['isInverted'];
}

export const SubRowToggle: FC<SubRowToggleProps> = ({
  isExpanded,
  handleToggle,
  className,
  iconExpandLessName = 'expandLess',
  iconExpandMoreName = 'expandMore',
  iconSize = 'small2',
  iconIsInverted,
}) => {
  const iconProps = {
    size: iconSize,
    isInverted: iconIsInverted,
  };
  return (
    <ToggleButton onClick={handleToggle} className={className}>
      {isExpanded ? (
        <Icon name={iconExpandLessName} {...iconProps} />
      ) : (
        <Icon name={iconExpandMoreName} {...iconProps} />
      )}
    </ToggleButton>
  );
};

const ToggleButton = styled.div`
  cursor: pointer;
`;
